import script from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=27e8c34a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e8c34a"]])

export default __exports__